import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages.css';

// Shared layout used by all 9 service detail pages
function ServicePage({ title, subtitle, img, imgAlt, overview, features, backAnchor }) {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="content-grid">
            <div>
              <img src={img} alt={imgAlt} style={{width: '100%', borderRadius: '10px'}} />
            </div>
            <div className="content-text">
              <h2 style={{color: 'var(--primary)', marginBottom: '20px'}}>Overview</h2>
              <ul className="overview-list">
                {overview.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{background: 'var(--light)'}}>
        <div className="container">
          <h2 className="section-title">Key Features</h2>
          <div className="why-choose-grid">
            {features.map((feature, i) => (
              <div key={i} className="why-card">
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{textAlign: 'center'}}>
          <Link to={backAnchor ? `/services#${backAnchor}` : '/services'}>
            <button className="btn btn-primary">Back to Services</button>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default ServicePage;
